import actions from '@/store/modules/ui/actions'
import getters from '@/store/modules/ui/getters'
import mutations from '@/store/modules/ui/mutations'

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  error: null
})

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}

export { getDefaultState }
